import { dataSyncManager } from '../service/DataSyncManager'
import {
  ExtensionPackageMetaData,
  UnparsedExtensionPackageModel,
  ExtensionPackageParsedModel,
  WorkflowPayload
} from '../types'
import { componentsToMap } from '../utils/components'
import { workflowEngineClient } from '../service/clients/WorkflowEngineClient'

export async function queryPackageExtensions(workflow: WorkflowPayload): Promise<ExtensionPackageParsedModel[]> {
  try {
    // This request will fail for each new connection.
    // This is why need to handle softly and fallback with empty array.
    const data = await dataSyncManager.sync<UnparsedExtensionPackageModel[]>(
      workflowEngineClient.getExtensionComponentsQuery(workflow),
      { workflow }
    )

    return data.map((entry) => {
      try {
        const parsedData = JSON.parse(entry.metadata)

        return {
          metadata: parsedData,
          name: entry.name
        }
      } catch {
        return {
          metadata: {} as ExtensionPackageMetaData,
          name: entry.name
        }
      }
    })
  } catch {
    return []
  }
}

export async function queryCustomComponents(workflow: WorkflowPayload) {
  const workflowEngineConnection = workflowEngineClient.getWorkflowEngineConnection(workflow)

  const query = workflowEngineConnection?.tempStoragePath ? workflowEngineConnection.getStoredProceduresQuery() : null

  // If this functionality is not available for some provider getStoredProceduresQuery will return null
  if (!query) return {}

  try {
    const response = await dataSyncManager.sync<{ ddl: string }[]>(query, { workflow })

    const procedures = workflowEngineConnection.getStoredProcedureComponentsFromQueryResponse(
      response.map((r) => r.ddl)
    )

    return componentsToMap(procedures.validComponents)
  } catch (e) {
    return
  }
}
